import $ from 'jquery';

import RTE from '../components/RTE';

export default class StaticFaq {
  constructor(section) {
    this.faq = section.el ? new RTE(section.el) : false;
    this.toggles = $('[data-faq-toggle]', section.el);

    this._bindEvents();
  }

  _bindEvents() {
    this.toggles.on('click', (event) => {
      $(event.currentTarget).toggleClass('active');
      $(event.currentTarget).next().stop().slideToggle(150);
    });
  }

  onSectionUnload() {
    if (this.faq) {
      this.faq.unload();
    }
  }

  onSectionBlockSelect(block) {
    const $trigger = $(block.el);

    if (!$trigger.hasClass('active')) {
      $trigger.trigger('click');
    }
  }
}
